module.exports = __webpack_public_path__ + "static/img/2_0_2@2x.b9c7aee.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_0_2@2x.png
// module id = 2w6U
// module chunks = 8